import { useState } from 'react';

interface CoinCellProps {
  asset: string;
  size?: number;
}

// Ticker with its crypto icon from the One Trading assets CDN; the image is
// dropped silently when the CDN has no icon for the code (e.g. fiat).
export const CoinCell = ({ asset, size = 22 }: CoinCellProps) => {
  const [isImageBroken, setIsImageBroken] = useState(false);

  return (
    <span className="inline-flex items-center gap-2">
      {isImageBroken ? null : (
        <img alt="" className="shrink-0" height={size} onError={() => setIsImageBroken(true)} src={`https://assets.onetrading.com/img/crypto/${asset}.svg`} width={size} />
      )}
      <span>{asset}</span>
    </span>
  );
};
CoinCell.displayName = 'CoinCell';
